<template>
    <div>
        <v-scroll-x-reverse-transition>
            <v-card rounded="lg" v-if="registered">
                <v-card-text>
                    <v-alert
                        class="py-6"
                        type="success"
                        color="primary darken-1"
                        prominent
                        border="top"
                        outlined
                    >
                        <h4>
                            You have successfully registered for access to the
                            Rent Well Tenant Sample Report online application portal.
                        </h4>
                    </v-alert>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary darken-1" :href="login_url">
                            <v-icon class="mr-2">mdi-key</v-icon>Continue to
                            login
                        </v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-scroll-x-reverse-transition>
        <v-scroll-x-transition>
            <v-card rounded="lg" v-if="!registered">
                <v-card-text>
                    <psi-form-section
                        ref="form"
                        :value="user"
                        name="student-data"
                        :fields="fields"
                        color="accent"
                        @update:password="updatePassword"
                    ></psi-form-section>
                    <v-alert v-if="error" color="error" icon="mdi-alert">
                        {{ error }}
                    </v-alert>
                    <v-card-actions class="justify-end">
                        <v-btn
                            color="primary"
                            @click="register"
                            :loading="dataLoading"
                        >
                            <v-icon class="mr-2">mdi-account-plus</v-icon
                            >Register</v-btn
                        >
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-scroll-x-transition>
    </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';

import store from '@/store';

export default {
    name: "register-user",
    props: {},
    data() {
        return {
            user: {},
            error: "",
            registered: false,
        };
    },
    computed: {
        ...mapGetters("Screens", ["dataLoading"]),
        login_url() {
            return this.$utils.loginUrl();
        },
        fields() {
            const idFields =
                this.user.registration_mode === "code"
                    ? [
                          {
                              type: "text",
                              name: "registration_code",
                              required: true,
                              key: "registration_code",
                              placeholder: "Enter registration code",
                              rules: [
                                  (v) =>
                                      v.length == 9 ||
                                      `Registration code must be 9 characters`,
                              ],
                              label: "Registration Code",
                              disabled: false,
                              icon: this.$config("icons.code"),
                          },
                      ]
                    : [
                          {
                              type: "text",
                              name: "email",
                              key: "email",
                              label: "Email",
                              disabled: true,
                              icon: this.$config("icons.email"),
                          },
                          {
                              type: "text",
                              format: "password",
                              required: true,
                              name: "password",
                              key: "password",
                              label: "Password",
                              validateOnBlur: false,
                              icon: this.$config("icons.password"),
                          },
                          {
                              type: "text",
                              format: "password",
                              required: true,
                              name: "password_confirm",
                              key: "password_confirm",
                              label: "Confirm Password",
                              validateOnBlur: false,
                              icon: this.$config("icons.password"),
                          },
                      ];
            return [
                {
                    type: "text",
                    required: true,
                    name: "name",
                    key: "name",
                    label: "Name",
                    icon: this.$config("icons.name"),
                },
            ].concat(idFields);
        },
    },
    methods: {
        ...mapActions("Screens", ["registerUser"]),
        ...mapActions("Snackbar", ["showMessage"]),
        async register() {
            if (this.$refs.form.validate()) {
                const result = await this.registerUser(this.user);
                if (result.error) {
                    this.error =
                        result.error +
                        " " +
                        this.$_.get(result, "error.response.data.message", "");
                } else if (
                    result.data.message.length > 0 &&
                    !result.data.error
                ) {
                    this.registered = true;
                }
            }
        },
        updatePassword(value) {
            const index = this.fields.findIndex(
                (field) => field.name === "password_confirm"
            );
            let field = this.fields[index];
            field.rules = [(v) => v === value || "Passwords do not match"];
            this.fields.splice(index, 1, field);
        },
    },
    async beforeRouteEnter(to, from, next) {
        const queryString = to.fullPath.replace(to.path, "");

        try {
            let result = await store.dispatch(
                "Screens/validateInvitedUser",
                queryString,
                { root: true }
            );

            if (result.status === "success") {
                if (result.user.registered) {
                    next({
                        name: "Login",
                        params: {},
                    });
                } else {
                    next((vm) => {
                        vm.user = result.user;
                    });
                }
            }
        } catch (error) {
            const {
                query: { signature = "" },
            } = to;
            signature.length > 0
                ? next({ name: "Register Error" })
                : next((vm) => {
                      vm.user = {
                          name: "",
                          registration_code: "",
                          registration_mode: "code",
                      };
                  });
        }
    },
};
</script>

<style lang="scss" scoped>
</style>